module.exports = __webpack_public_path__ + "img/poly-4.386e8553.png";